<template>
    <div class="main-body">
        <cabecalho-padrao/>
    
        <section class="sub-menu-body">
            <sub-menu/>
            <div class="main">

              <div class="form-grid">
                <div class="wrapper">
                    <div class="header">
                        <h1>Consulta Receitas</h1>
                        <h3>Controle aqui todas as suas receitas</h3>
                    </div>
                    
                    <div class="pagecontrol">
                        <ul class="tabs">
                            <li><a :class="{ active: pesquisa.abafiltro === 'todos' }"  @click="MudarAba('todos')">Todas Receitas</a></li>
                        </ul>
                        <div class="wrapper-filtro">
                            <div>
                                <div class="filtro">
                                    <div class="custom-select-wrapper">
                                        <span class="icon"><img src="../../assets/calendar.png" alt="calendario"></span>                            
                                        <select v-model="pesquisa.filtroPeriodo" id="filtroPeriodo" class="custom-select"  @change="listar(false)">
                                            <option value="mes_atual">Mês: {{nomeMesAtual}}</option>
                                            <option value="ultimos_30">Últimos 30 dias</option>
                                            <option value="ultimos_6m">Últimos 6 meses</option>
                                            <option value="periodo">Período</option>
                                        </select>
                                        <!-- Inputs só aparecem se "Período" for escolhido -->
                                        <div v-if="pesquisa.filtroPeriodo === 'periodo'" class="periodo-inputs">
                                            <input type="date" v-model="pesquisa.DtInicial" class="input-date" @change="listar(false)"/>
                                            <input type="date" v-model="pesquisa.DtFinal" class="input-date" @change="listar(false)"/>

                                        </div>                                    
                                    </div>

                                    <div class="custom-select-wrapper">
                                        <span class="icon"><img src="../../assets/dollar-symbol.png" alt="valores"></span> 
                                        <select v-model="pesquisa.filtroTipoValor" id="filtroTipoValor" class="custom-select" @change="listar(false)">
                                            <option value="todos">Todos</option>                                
                                            <option value="aberto">Em Aberto</option>
                                            <option value="pago">Pagos</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="paginacao">
                                    <label> Pagina: {{paginaAtual}} de {{qtdePagina}} </label>
                                    <button @click="Paginacao(-1)"><img src="../../assets/left-arrow-gray.png"></button>
                                    <button @click="Paginacao(1)"><img src="../../assets/right-arrow-gray.png"></button>
                                </div>
                            </div>
                            <div class="totais">
                                <h2>Todos R${{ValorTotal}}</h2>
                                <h2 class="-cor-vermelho">Em Aberto R${{ValorAberto}}</h2>
                                <h2 class="-cor-verde">Pagos R${{ValorPago}}</h2>
                            </div>
                        </div>

                        <section class="grid-large">
                            <div class="grid-colunas">
                                <div v-for="col in colunas" :key="col.field" class="grid-col"  :style="col.style">
                                    {{col.label}}
                                </div>
                            </div>
                            <div class="grid-colunas -conteudo" v-for="lin in lista" :key="lin.id">
				                <div v-for="col in colunas" :key="col.field" class="grid-col -conteudo"  :style="col.style">                       
                                    <div v-if="col.field=='acao'">
                                        ...
                                    </div>   
                                    <div  v-else-if="col.field=='Valor_aberto'" class="-cor-vermelho" >
                                       {{ formatarColuna(lin,col.field)}}
                                    </div> 
                                    <div  v-else-if="col.field=='Pago'" class="-cor-verde" >
                                       {{ formatarColuna(lin,col.field)}}
                                    </div>                                     
                                    <div v-else>                               
                                       {{ formatarColuna(lin,col.field)}}
                                    </div>   
                                </div>                              
                            </div>
                        </section>
                        <section class="grid-thin">
                            <div class="grid-card" v-for="lin in lista" :key="lin.id">
                                <div class="card-linha">
                                    <div>
                                        Vencimento: {{formatarColuna(lin,'Data_vencimento')}}
                                    </div>
                                    <div>
                                        <div class="-cor-vermelho" v-if="lin['Valor_aberto']>0">
                                            Em aberto: {{formatarColuna(lin,'Valor_aberto')}}
                                        </div>          
                                        <div class="-cor-verde"  v-if="lin['Valor_pago']>0">
                                            <div>Recebido:</div> <div>{{formatarColuna(lin,'Pago')}}</div>
                                        </div>    
                                    </div>    
                                </div>       
                                <div>
                                    <div>
                                        {{formatarColuna(lin,'descricao')}}
                                    </div>                                
                                </div>     
                                <div>
                                    <div>
                                        {{formatarColuna(lin,'Conta')}}
                                    </div>                                
                                </div>                                                                             
                            </div>
                        </section>
                    </div>





                </div>
      

                
              </div>    

            </div>
        </section>

    </div>
</template>

<script>
import CabecalhoPadrao from '../../components/Cabecalho.vue';
import subMenuReceber from '../../components/subMenuReceber.vue';
import api from '../../services/api.js';

export default {
  name: 'Mais',
  components:{
    'cabecalho-padrao': CabecalhoPadrao,
    'sub-menu': subMenuReceber
  },
  data: () => ({
            pesquisa:{
                abafiltro : "todos",
                filtroPeriodo: "mes_atual",
                filtroTipoValor: "aberto",
                DtInicial: '',
                DtFinal: '',
                limitIni: 0,
                limitFim: 20
            },
            colunas:[
                {field:'Cod_duplicata', label:'Controle',  style: 'flex:1; min-width: 50px;'},
                {field:'Data_vencimento', label:'Vencimento',  style: 'flex:1; min-width: 80px;'},
                {field:'descricao',label:'Descrição',  style: 'flex:3; width: 400px;'},
                {field:'Valor_aberto',label:'Em Aberto',  style: 'flex:1; min-width: 90px; text-align: right;'},
                {field:'Pago',label:'Recebido',style: 'flex:1; min-width: 90px; text-align: right;'},
                {field:'Conta',label:'Conta/Subs',style: 'flex:3; width: 200px;'},
                {field:'acao',label:'AÇÃO',style: 'flex:1; min-width: 50px;'},

            ],         
            lista:[],  
            paginaAtual:1,
            qtdePagina:1,
            nomeMesAtual: "Set/2025",
            ValorTotal:0, 
            ValorAberto:0,
            ValorPago:0,
            qtdeRegistros:0,
             

  }),
  methods: {
        Novo(){
            this.$router.push('/receitas/novo/0');
        },
        Alterar(id){
            this.$router.push('/receitas/novo/'+id);

        },
        async Excluir(id){
            alert('excluir em construção');
        },
        formatarColuna(data,field){
            if (field=='descricao'){
                let descricao = '';

                if (data['N_duplicata']!=''){
                    if (descricao!='') 
                        descricao = descricao + ' ';
                    descricao = descricao + data['N_duplicata'];
                    if (data['Desdobramento']!=''){
                        descricao = descricao + '/'+data['Desdobramento'];
                    }                                         
                } 
                else               
                if (data['Desdobramento']!=''){
                    if (descricao!='') 
                        descricao = descricao + ' ';                    
                    descricao = descricao + data['Desdobramento'];
                }              
                     
                if  (data['Cod_cliente']!=0)
                    descricao = descricao + '('+data['Cod_cliente']+')'+data['Cod_cliente']
                else 
                    descricao = descricao + data['Cod_cliente'];

                if (data['Historico']!=''){
                    if (descricao!='') 
                        descricao = descricao + ' Hist.: ';                    
                    descricao = descricao + data['Historico'];
                }              
                return descricao;
            }
            else
            if (field=='Valor'){
                let valor = '';
                if ((data['Valor_aberto'] > 0) && (data['Valor_pago'] == 0))
                    valor = 'Aberto '+this.formatarValor(data['Valor_aberto']) 
                else
                if ((data['Valor_aberto'] > 0) && (data['Valor_pago'] > 0))
                    valor = 'Recebido Parcial' +this.formatarValor(data['Valor_pago']);      
                else
                if ((data['Valor_aberto'] == 0) && (data['Valor_pago'] > 0))
                    valor = 'Recebido '+this.formatarValor(data['Valor_pago']) +' '+data['data_pago'];

                return valor
            }
            else      
            if (field=='Valor_aberto'){
                return this.formatarValor(data['Valor_aberto']);
            }
            else             
            if (field=='Pago'){
                let valor = this.formatarValor(0);

                if (data['Valor_pago'] > 0)
                    valor = this.formatarValor(data['Valor_pago']) +' '+this.formatarData(data['data_pago']);

                return valor
            }
            else 
            if (field=='Conta'){
                let descricao = '';                 
                if (data['Nome_conta']!=''){
                    if (descricao!='')
                        descricao = descricao +', ';
                    descricao = descricao + data['Nome_conta'];
                }       
                if (data['Nome_sub_conta']!=''){
                    if (descricao!='')
                        descricao = descricao +', ';
                    descricao = descricao + data['Nome_sub_conta'];
                }                                
                if (data['Nome_sub_conta2']!=''){
                    if (descricao!='')
                        descricao = descricao +', ';
                    descricao = descricao + data['Nome_sub_conta2'];
                }                       
                if (data['Nome_sub_conta3']!=''){
                    if (descricao!='')
                        descricao = descricao +', ';
                    descricao = descricao + data['Nome_sub_conta3'];
                }       

                return descricao;
            }                       
            return data[field];
        },
        formatarData(data) {
            const [ano, mes, dia] = data.split('-');
            return `${dia}/${mes}/${ano}`;
        },       
        formatarValor(v){
            var format = new Intl.NumberFormat('pt-BR', {minimumFractionDigits: 2});                                    
            return format.format(v);
        },      
        async Paginacao(soma){
            if ((this.paginaAtual+soma)<1)
                this.paginaAtual = 1
            else 
            if ((this.paginaAtual+soma)>this.qtdePagina)
                this.paginaAtual = this.qtdePagina
            else{
                this.paginaAtual = this.paginaAtual+soma;
                this.listar(true);
            }

            
        },    
        async MudarAba(aba){
            this.pesquisa.abafiltro = aba;
            this.listar(false);
        },
        async listar(Paginacao){
            try {
                if (this.pesquisa.filtroPeriodo=="mes_atual") {
                    const hoje = new Date();
                    const ano = hoje.getFullYear();
                    const mes = String(hoje.getMonth() + 1).padStart(2, '0');

                    this.pesquisa.DtInicial = `${ano}-${mes}-01`;
                    const lastDay = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
                
                    const dia = String(lastDay.getDate()).padStart(2, '0');
                    this.pesquisa.DtFinal = `${ano}-${mes}-${dia}`;   
                }
                else
                if (this.pesquisa.filtroPeriodo=="ultimos_30") {
                    const hoje = new Date();
                    let ano = hoje.getFullYear();
                    let mes = String(hoje.getMonth() + 1).padStart(2, '0');    
                    let dia = String(hoje.getDate()).padStart(2, '0');                

                    this.pesquisa.DtFinal = `${ano}-${mes}-${dia}`;                       

                    // Data inicial = hoje - 30 dias
                    const dataInicial = new Date();
                    dataInicial.setDate(dataInicial.getDate() - 30);
                    ano = dataInicial.getFullYear();
                    mes = String(dataInicial.getMonth() + 1).padStart(2, '0');    
                    dia = String(dataInicial.getDate()).padStart(2, '0');                         

                    this.pesquisa.DtInicial = `${ano}-${mes}-${dia}`;           

                }
                else
                if (this.pesquisa.filtroPeriodo=="ultimos_6m") {
                    const hoje = new Date();
                    let ano = hoje.getFullYear();
                    let mes = String(hoje.getMonth() + 1).padStart(2, '0');    
                    let dia = String(hoje.getDate()).padStart(2, '0');                

                    this.pesquisa.DtFinal = `${ano}-${mes}-${dia}`;                       

                    // Data inicial = hoje - 180 dias
                    const dataInicial = new Date();
                    dataInicial.setDate(dataInicial.getDate() - 180);
                    ano = dataInicial.getFullYear();
                    mes = String(dataInicial.getMonth() + 1).padStart(2, '0');    
                    dia = String(dataInicial.getDate()).padStart(2, '0');                         

                    this.pesquisa.DtInicial = `${ano}-${mes}-${dia}`;           

                }

                if (Paginacao==false){
                    this.pesquisa.limitIni = 0;
                    this.pesquisa.limitFim = 20;
                    this.paginaAtual = 1;
                }
                else{
                    this.pesquisa.limitIni = 20*(this.paginaAtual-1);
                    this.pesquisa.limitFim = 20;
                }
                
                //let pesquisa = {DtInicial: 0, DtFinal: 0, DtMes: new Date(), tipoData: 'EMISSAO', LIMIT: this.limit};
                console.log('receber');
                const response = await api.post('receber/listar',this.pesquisa); // Aguarda a resposta da API
                console.log(response);

                // Formata os valores recebidos
                var format = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 });
                this.ValorAberto = format.format(response.data.valor_aberto);
                this.ValorTotal = format.format(response.data.valor_total); 
                this.ValorPago = format.format(response.data.valor_pago); 
                this.qtdeRegistros = response.data.count;
                this.lista = response.data.qry;

                this.qtdePagina = Math.round(this.qtdeRegistros/20);
                if (this.qtdePagina<(this.qtdeRegistros/20))
                    this.qtdePagina = this.qtdePagina+1;

                

            } catch (error) {
                console.log(error);
                alert('Error - listar \n' + '-' + error.response?.data || error.message);
            }
        },
        async PreencherDatas(){
            return new Promise((resolve) => {


                resolve();
            });

            
     
        }
    },
    
    computed: {
             
    },
    async created(){
        const hoje = new Date();
        const ano = hoje.getFullYear();
        const mes = String(hoje.getMonth() + 1).padStart(2, '0');

        this.pesquisa.DtInicial = `${ano}-${mes}-01`;
        const lastDay = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

        const dia = String(lastDay.getDate()).padStart(2, '0');
        this.pesquisa.DtFinal = `${ano}-${mes}-${dia}`;   

        this.nomeMesAtual =  hoje.toLocaleString("pt-BR", { month: "short" }).toUpperCase()+'/'+ano;



        await this.listar();
    }
}
</script>

<style>
  @import '../../css/components/sub-menu-body.css';
  @import '../../css/components/form-grid.css';
  @import '../../css/components/custom/custom-select.css';

</style>